<template>
    <div class="flex h-full flex-col">
        <banner-carousel :banners="activeBanners" />
        <!-- Top nav-->
        <header
            class="relative shadow-md flex h-16 shrink-0 items-center bg-sky-500 md:bg-white"
        >
            <!-- Logo area -->
            <div class="absolute inset-y-0 left-0 md:static md:shrink-0">
                <router-link
                    :to="{ name: 'ProjectFlagsScreen', params: current }"
                    class="flex h-16 w-16 items-center justify-center bg-sky-500 focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-white md:w-20"
                    aria-label="Zenmanage home"
                >
                    <svg
                        class="h-8 w-8"
                        aria-hidden="true"
                        width="57.811763763427734"
                        height="57.826480865478516"
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.com/svgjs"
                        viewBox="0 0 57.811763763427734 57.826480865478516"
                    >
                        <defs></defs>
                        <rect
                            width="57.811763763427734"
                            height="57.826480865478516"
                            fill="transparent"
                        ></rect>
                        <g
                            transform="matrix(1,0,0,1,-55.88774490356445,-53.58749008178711)"
                        >
                            <path
                                d="M103.354,63.931h0c-1.904-1.904-4.437-2.953-7.13-2.953s-5.226,1.049-7.13,2.953c-1.905,1.905-2.954,4.437-2.954,7.13s1.049,5.226,2.954,7.13c1.904,1.904,4.437,2.953,7.13,2.953s5.225-1.049,7.13-2.953c1.905-1.904,2.954-4.437,2.954-7.13s-1.049-5.226-2.953-7.13Zm-3.271,10.99c-1.031,1.031-2.401,1.598-3.859,1.598s-2.829-.568-3.86-1.598c-1.031-1.031-1.599-2.402-1.599-3.859s.568-2.829,1.599-3.859,2.402-1.599,3.86-1.599,2.828,.568,3.859,1.598h0c1.031,1.031,1.598,2.402,1.598,3.86s-.568,2.828-1.599,3.859Zm-.959-3.859c0,1.601-1.298,2.9-2.9,2.9s-2.9-1.299-2.9-2.9,1.298-2.9,2.9-2.9,2.9,1.299,2.9,2.9Zm3.357,29.203c-.166,.166-.321,.34-.465,.519-1.422-1.42-2.312-3.372-2.312-5.535,0-1.711,.559-3.357,1.568-4.703l7.347-7.347c6.774-6.774,6.774-17.757,0-24.531h0c-6.774-6.774-17.757-6.774-24.531,0l-7.443,7.443c-1.325,.957-2.927,1.489-4.59,1.489-2.164,0-4.116-.89-5.536-2.312,.179-.145,.353-.299,.52-.466,2.547-2.547,2.547-6.69,0-9.236s-6.69-2.546-9.236,0c-2.547,2.547-2.547,6.69,0,9.236,1.094,1.094,2.484,1.715,3.916,1.869,2.239,3.331,6.029,5.534,10.336,5.534,2.677,0,5.254-.863,7.376-2.419-.031,.415-.052,.833-.052,1.257,0,.929,.078,1.84,.223,2.728l-5.104,5.103c-.04,.036-.085,.064-.124,.103-1.634,1.657-3.532,2.643-5.458,2.949-.132-1.472-.758-2.908-1.882-4.032-2.546-2.546-6.689-2.547-9.236,0-2.547,2.547-2.547,6.69,0,9.236,1.273,1.273,2.946,1.91,4.618,1.91s3.345-.637,4.618-1.91c.151-.151,.292-.309,.425-.47,.058,0,.116,.006,.174,.006,3.483,0,6.987-1.456,9.842-4.264,.064-.052,.132-.097,.192-.157l3.551-3.551c.454,.888,.982,1.732,1.58,2.52l-17.678,17.677c-2.403-1.078-5.326-.64-7.296,1.331-2.547,2.547-2.547,6.69,0,9.236,1.273,1.273,2.946,1.91,4.618,1.91s3.345-.637,4.618-1.91c1.97-1.97,2.409-4.893,1.331-7.296l17.68-17.68c.789,.597,1.634,1.124,2.523,1.576l-3.557,3.557c-.054,.054-.094,.116-.141,.173-2.863,2.903-4.306,6.481-4.26,10.023-.167,.136-.328,.282-.484,.437-2.547,2.547-2.547,6.69,0,9.236,1.273,1.273,2.946,1.91,4.618,1.91s3.345-.637,4.618-1.91c2.547-2.547,2.547-6.69,0-9.236-1.124-1.124-2.559-1.75-4.031-1.882,.307-1.926,1.292-3.825,2.949-5.458,.039-.038,.066-.083,.102-.123l5.116-5.117c.879,.142,1.78,.218,2.699,.218,.426,0,.847-.021,1.265-.052l.013,.012c-1.559,2.122-2.423,4.702-2.423,7.381,0,4.307,2.203,8.097,5.534,10.336,.153,1.431,.774,2.821,1.869,3.916,1.273,1.273,2.946,1.91,4.618,1.91s3.345-.637,4.618-1.91c2.547-2.547,2.547-6.69,0-9.236-2.546-2.546-6.689-2.547-9.236,0ZM61.073,58.856c.372-.372,.859-.557,1.348-.557s.976,.186,1.347,.557c.743,.743,.743,1.951,0,2.695-.743,.743-1.952,.743-2.695,0-.743-.743-.743-1.952,0-2.695Zm2.691,25.023c-.743,.743-1.951,.743-2.695,0-.743-.743-.743-1.952,0-2.695,.372-.372,.859-.557,1.347-.557s.976,.186,1.348,.557c.743,.743,.743,1.952,0,2.695Zm.026,22.328c-.743,.743-1.951,.743-2.695,0-.743-.743-.743-1.952,0-2.695,.372-.372,.859-.557,1.347-.557s.976,.186,1.348,.557c.743,.743,.743,1.951,0,2.695Zm22.328,.026c-.743,.743-1.952,.743-2.695,0-.743-.743-.743-1.952,0-2.695,.372-.372,.859-.557,1.348-.557s.976,.186,1.347,.557c.743,.743,.743,1.951,0,2.695Zm1.153-26.22c-4.944-4.944-4.944-12.961,0-17.905,4.944-4.944,12.961-4.944,17.905,0,4.944,4.944,4.944,12.961,0,17.905-4.944,4.944-12.961,4.944-17.905,0Zm21.175,26.216c-.743,.742-1.951,.743-2.695,0-.743-.743-.743-1.952,0-2.695,.372-.372,.859-.557,1.347-.557s.976,.186,1.348,.557c.743,.743,.743,1.951,0,2.695Z"
                                fill="#ffffff"
                            ></path>
                        </g>
                    </svg>
                </router-link>
            </div>

            <!-- Menu button area -->
            <div
                class="absolute inset-y-0 right-0 flex items-center pr-4 sm:pr-6 md:hidden"
            >
                <button
                    type="button"
                    @click="openHelp"
                    class="cursor-pointer mr-2 inline-flex items-center justify-center rounded-md p-2 text-white bg-sky-400 hover:bg-white hover:text-sky-500 focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-sky-300"
                    data-testid="mobile-nav-help-button"
                    aria-label="Open help"
                >
                    <span class="sr-only">Open help</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        class="h-6 w-6"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M8.625 9a3.375 3.375 0 116.75 0c0 1.8-1.206 2.522-2.34 3.2-.934.559-1.785 1.068-1.785 2.175m0 3h.008"
                        />
                    </svg>
                </button>
                <!-- Mobile menu button -->
                <button
                    type="button"
                    @click="toggleMobileMenu"
                    :aria-expanded="showMobileMenu"
                    aria-controls="mobile-menu"
                    class="cursor-pointer -mr-2 inline-flex items-center justify-center rounded-md p-2 text-white bg-sky-400 hover:bg-white hover:text-sky-500 focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-sky-300"
                >
                    <span class="sr-only">Open main menu</span>
                    <svg
                        class="block h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                        />
                    </svg>
                </button>
            </div>

            <!-- Desktop nav area -->
            <div
                class="hidden md:flex md:min-w-0 md:flex-1 md:items-center md:justify-between"
            >
                <div class="min-w-0 flex-1 flex ml-4 space-x-2">
                    <environment-picker
                        data-tour="environment-picker"
                        :active="showSidebar"
                        @changed="environmentChanged"
                    />
                    <zen-tooltip
                        v-if="showAdmin"
                        content="Admin"
                        placement="right"
                        v-slot="{ setReference, ariaAttrs, show, hide }"
                    >
                        <router-link
                            :to="{ name: 'AdminProjectsScreen' }"
                            :ref="setReference"
                            v-bind="ariaAttrs"
                            class="h-full min-h-full rounded-lg focus:outline-hidden focus:ring-2 focus:ring-sky-600 focus:ring-offset-2"
                            aria-label="Admin"
                            @mouseenter="show"
                            @mouseleave="hide"
                            @focus="show"
                            @blur="hide"
                        >
                            <div
                                class="flex border h-full rounded-lg py-2 max-w-2xl hover:text-red-500 focus-within:text-red-500"
                                :class="[
                                    isAdmin
                                        ? 'border-red-500 text-red-500'
                                        : 'text-taupe-500',
                                ]"
                            >
                                <ol class="flex items-center space-x-1">
                                    <li>
                                        <div class="flex items-center">
                                            <div
                                                class="mx-2 text-sm font-medium hover:text-red-500 h-full border border-white"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="2"
                                                    stroke="currentColor"
                                                    class="w-6 h-6"
                                                    aria-hidden="true"
                                                >
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z"
                                                    />
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </li>
                                </ol>
                            </div>
                        </router-link>
                    </zen-tooltip>
                </div>
                <div class="ml-10 flex shrink-0 items-center space-x-10 pr-4">
                    <div class="flex items-center space-x-4">
                        <zen-tooltip
                            content="Help"
                            placement="bottom"
                            v-slot="{ setReference, ariaAttrs, show, hide }"
                        >
                            <button
                                type="button"
                                :ref="setReference"
                                v-bind="ariaAttrs"
                                @click="openHelp"
                                @mouseenter="show"
                                @mouseleave="hide"
                                @focus="show"
                                @blur="hide"
                                class="cursor-pointer inline-flex items-center justify-center rounded-full border border-taupe-200 bg-white p-2 text-taupe-600 shadow-xs hover:border-sky-400 hover:text-sky-600 focus:outline-hidden focus:ring-2 focus:ring-sky-600 focus:ring-offset-2"
                                data-testid="top-nav-help-button"
                                data-tour="help-button"
                                aria-label="Open help"
                            >
                                <span class="sr-only">Open help</span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="2"
                                    stroke="currentColor"
                                    class="h-5 w-5"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M8.625 9a3.375 3.375 0 116.75 0c0 1.8-1.206 2.522-2.34 3.2-.934.559-1.785 1.068-1.785 2.175m0 3h.008"
                                    />
                                </svg>
                            </button>
                        </zen-tooltip>

                        <zen-dropdown-menu
                            placement="bottom-end"
                            menu-class="w-56 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden"
                        >
                            <template
                                v-slot:trigger="{
                                    toggle,
                                    setReference,
                                    ariaAttrs,
                                }"
                            >
                                <button
                                    type="button"
                                    :ref="setReference"
                                    @click="toggle"
                                    v-bind="ariaAttrs"
                                    class="cursor-pointer flex rounded-full bg-white text-sm focus:outline-hidden focus:ring-2 focus:ring-sky-600 focus:ring-offset-2"
                                    id="menu-0-button"
                                >
                                    <span class="sr-only">Open user menu</span>
                                    <img
                                        class="h-8 w-8 rounded-full"
                                        :src="avatar"
                                        alt=""
                                    />
                                </button>
                            </template>
                            <template v-slot:default="{ close }">
                                <div
                                    role="menu"
                                    aria-orientation="vertical"
                                    aria-labelledby="menu-0-button"
                                    tabindex="-1"
                                >
                                    <div class="p-1">
                                        <button
                                            @click="
                                                () => {
                                                    profile()
                                                    close()
                                                }
                                            "
                                            class="cursor-pointer block w-full text-left px-4 py-2 text-sm text-taupe-800 rounded-md hover:bg-sky-200"
                                            role="menuitem"
                                            tabindex="-1"
                                            id="menu-0-item-0"
                                        >
                                            Your Profile
                                        </button>
                                        <button
                                            @click="
                                                () => {
                                                    restartTour()
                                                    close()
                                                }
                                            "
                                            class="cursor-pointer block w-full text-left px-4 py-2 text-sm text-taupe-800 rounded-md hover:bg-sky-200"
                                            role="menuitem"
                                            tabindex="-1"
                                            data-testid="profile-menu-restart-tour-button"
                                        >
                                            Restart Tour
                                        </button>
                                        <button
                                            v-if="showOnboardingButton"
                                            @click="
                                                () => {
                                                    openSdkWizardFromMenu()
                                                    close()
                                                }
                                            "
                                            class="cursor-pointer block w-full text-left px-4 py-2 text-sm text-taupe-800 rounded-md hover:bg-sky-200"
                                            role="menuitem"
                                            tabindex="-1"
                                            data-testid="profile-menu-connect-sdk-button"
                                        >
                                            Connect your SDK
                                        </button>
                                        <hr
                                            v-if="showOnboardingButton"
                                            class="my-1 border-taupe-200"
                                        />
                                        <button
                                            @click="
                                                () => {
                                                    signout()
                                                    close()
                                                }
                                            "
                                            class="cursor-pointer block w-full text-left px-4 py-2 text-sm text-taupe-800 rounded-md hover:bg-sky-200"
                                            role="menuitem"
                                            tabindex="-1"
                                            id="menu-0-item-1"
                                        >
                                            Sign Out
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </zen-dropdown-menu>
                    </div>
                </div>
            </div>

            <!-- Mobile menu, rendered only while open so its dialog role and modal semantics don't apply to assistive tech when closed -->
            <mobile-nav-menu
                :is-open="showMobileMenu"
                :current="current"
                :show-sidebar="showSidebar"
                :show-admin="showAdmin"
                :is-trial="isTrial"
                :is-admin-user="isAdminUser"
                :can-manage-billing="canManageBilling"
                :onboarding-store="onboardingStore"
                :avatar="avatar"
                :user="user"
                :environment-changed="environmentChanged"
                :signout="signout"
                @close="showMobileMenu = false"
            />
        </header>

        <!-- Bottom section -->
        <div class="flex min-h-0 flex-1 overflow-hidden">
            <!-- Narrow sidebar-->
            <nav
                aria-label="Sidebar"
                class="hidden md:block md:shrink-0 md:bg-taupe-700"
            >
                <div class="relative flex w-20 flex-col space-y-3 p-3">
                    <zen-tooltip
                        v-if="showSidebar"
                        content="Flags"
                        placement="right"
                        v-slot="{ setReference, ariaAttrs, show, hide }"
                    >
                        <router-link
                            :to="{
                                name: 'ProjectFlagsScreen',
                                params: current,
                            }"
                            :ref="setReference"
                            v-bind="ariaAttrs"
                            :class="[isFlags ? selected : unselected]"
                            class="shrink-0 inline-flex items-center justify-center h-14 w-14 rounded-lg"
                            data-tour="flags-nav"
                            @mouseenter="show"
                            @mouseleave="hide"
                            @focus="show"
                            @blur="hide"
                        >
                            <span class="sr-only">Flags</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="2"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 13.5V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 010 3m0-3a1.5 1.5 0 000 3m0 9.75V10.5"
                                />
                            </svg>
                        </router-link>
                    </zen-tooltip>
                    <zen-tooltip
                        v-if="showSidebar"
                        content="Contexts"
                        placement="right"
                        v-slot="{ setReference, ariaAttrs, show, hide }"
                    >
                        <router-link
                            :to="{
                                name: 'ProjectContextsScreen',
                                params: current,
                            }"
                            :ref="setReference"
                            v-bind="ariaAttrs"
                            :class="[isContexts ? selected : unselected]"
                            class="shrink-0 inline-flex items-center justify-center h-14 w-14 rounded-lg"
                            @mouseenter="show"
                            @mouseleave="hide"
                            @focus="show"
                            @blur="hide"
                        >
                            <span class="sr-only">Contexts</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                                />
                            </svg>
                        </router-link>
                    </zen-tooltip>
                    <zen-tooltip
                        v-if="showSidebar"
                        content="Segments"
                        placement="right"
                        v-slot="{ setReference, ariaAttrs, show, hide }"
                    >
                        <router-link
                            :to="{
                                name: 'ProjectSegmentsScreen',
                                params: current,
                            }"
                            :ref="setReference"
                            v-bind="ariaAttrs"
                            :class="[isSegments ? selected : unselected]"
                            class="shrink-0 inline-flex items-center justify-center h-14 w-14 rounded-lg"
                            @mouseenter="show"
                            @mouseleave="hide"
                            @focus="show"
                            @blur="hide"
                        >
                            <span class="sr-only">Segments</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                                />
                            </svg>
                        </router-link>
                    </zen-tooltip>
                    <zen-tooltip
                        v-if="showSidebar"
                        content="Debug Console"
                        placement="right"
                        v-slot="{ setReference, ariaAttrs, show, hide }"
                    >
                        <router-link
                            :to="{
                                name: 'ProjectDebugConsoleScreen',
                                params: current,
                            }"
                            :ref="setReference"
                            v-bind="ariaAttrs"
                            :class="[isDebug ? selected : unselected]"
                            class="shrink-0 inline-flex items-center justify-center h-14 w-14 rounded-lg"
                            @mouseenter="show"
                            @mouseleave="hide"
                            @focus="show"
                            @blur="hide"
                        >
                            <span class="sr-only">Debug Console</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="2"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z"
                                />
                            </svg>
                        </router-link>
                    </zen-tooltip>
                    <zen-tooltip
                        v-if="showSidebar"
                        content="Reports"
                        placement="right"
                        v-slot="{ setReference, ariaAttrs, show, hide }"
                    >
                        <router-link
                            :to="{
                                name: 'ProjectReportsScreen',
                                params: current,
                            }"
                            :ref="setReference"
                            v-bind="ariaAttrs"
                            :class="[isReports ? selected : unselected]"
                            class="shrink-0 inline-flex items-center justify-center h-14 w-14 rounded-lg"
                            @mouseenter="show"
                            @mouseleave="hide"
                            @focus="show"
                            @blur="hide"
                        >
                            <span class="sr-only">Reports</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="2"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z"
                                />
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z"
                                />
                            </svg>
                        </router-link>
                    </zen-tooltip>
                </div>
            </nav>
            <!-- Main area: the notice sits at its top, beside the left nav. Flags screens render their own notice beside the flag list. -->
            <div class="flex min-h-0 min-w-0 flex-1 flex-col">
                <environment-overlay-banner
                    v-if="
                        showEnvironmentOverlayBanner &&
                        current.projectKey &&
                        current.environmentKey
                    "
                    :project-key="current.projectKey"
                    :environment-key="current.environmentKey"
                />
                <router-view
                    :key="routeViewKey"
                    class="min-h-0 flex-1"
                ></router-view>
            </div>
        </div>

        <sdk-setup-wizard
            :isOpen="showSdkWizard"
            :accountUlid="account.ulid"
            :clientKey="currentEnvironmentKeys.clientKey"
            :mobileKey="currentEnvironmentKeys.mobileKey"
            :serverKey="currentEnvironmentKeys.serverKey"
            @close="showSdkWizard = false"
        />

        <getting-started-checklist
            v-if="showOnboardingButton && isAdminUser"
            @open-sdk-wizard="showSdkWizard = true"
        />

        <product-tour
            v-if="user"
            :active="productTour.active.value"
            :current-step="productTour.currentStep.value"
            @next="productTour.next()"
            @back="productTour.back()"
            @skip="productTour.skip()"
        />

        <contact-support-slide-in
            :is-open="support.show"
            v-model:subject="support.subject"
            v-model:message="support.message"
            :error="support.error"
            :processing="support.processing"
            @close="closeSupport"
            @submit="submitSupport"
        />
    </div>
</template>

<script>
import EnvironmentPicker from '@/screens/_components/EnvironmentPicker/EnvironmentPicker.vue'
import EnvironmentOverlayBanner from '@/screens/_components/EnvironmentOverlayBanner.vue'
import SdkSetupWizard from '@/screens/_components/onboarding/SdkSetupWizard.vue'
import GettingStartedChecklist from '@/screens/_components/onboarding/GettingStartedChecklist.vue'
import ProductTour from '@/screens/_components/onboarding/ProductTour.vue'
import MobileNavMenu from '@/screens/_templates/modals/MobileNavMenu.vue'
import ContactSupportSlideIn from '@/screens/_templates/modals/ContactSupportSlideIn.vue'
import { useOnboardingStore } from '@/stores/onboarding'
import { useProductTour } from '@/composables/useProductTour'
import AnnouncementBanner, {
    bgClass as announcementBgClass,
} from '@/screens/_components/onboarding/AnnouncementBanner.vue'
import BannerCarousel from '@/screens/_components/onboarding/BannerCarousel.vue'
import BillingStatusBanner from '@/screens/_components/onboarding/BillingStatusBanner.vue'
import { bgClassFor as billingStatusBgClassFor } from '@/helpers/billing-status-alert'
import { usePermissions, PERMISSIONS } from '@/composables/usePermissions'
import { computed, onBeforeUnmount, watch } from 'vue'
import { useAccountEventsStore } from '@/stores/account-events'
import { useBillingStore } from '@/stores/billing'
import { useSessionStore } from '@/stores/session'
import { useAuthStore } from '@/stores/auth'
import { getFlag } from '@/utils/feature-flags'
import { useFlagValue } from '@/composables/useFlagValue'
import SupportTicketService from '@/services/support-ticket.service'
import { errorMessage, successMessage } from '@/utils/notifications'

import moment from 'moment'

export default {
    name: 'TrustedTemplate',
    setup() {
        const { isAdmin: isAdminUser, can } = usePermissions()
        const onboardingStore = useOnboardingStore()
        const canManageBilling = computed(() => can(PERMISSIONS.BILLING_UPDATE))
        const sessionStore = useSessionStore()
        const userUlid = computed(
            () => sessionStore.data?.user?.data?.ulid ?? 'unknown'
        )
        const productTour = useProductTour(userUlid)
        const { value: applicationMessage, ready: applicationMessageReady } =
            useFlagValue('application-message', '')

        // One realtime connection for the signed-in account, shared by every
        // screen that listens. It follows the session: it opens once the
        // account is known and closes on sign-out or when the account changes.
        const accountEventsStore = useAccountEventsStore()
        watch(
            () => sessionStore.data?.account?.data?.ulid ?? null,
            (accountUlid) => accountEventsStore.connect(accountUlid),
            { immediate: true }
        )
        onBeforeUnmount(() => accountEventsStore.disconnect())

        // The cached flag list follows flag changes made outside this tab, so
        // the flags screen and anything reading the cache stay current.
        sessionStore.listenForFlagChanges()
        onBeforeUnmount(() => sessionStore.unlistenForFlagChanges())

        // The billing banner comes from the billing store's status alert, the
        // same one the billing page shows, so the two never disagree. Only
        // people who can read billing can load the alert.
        const billingStore = useBillingStore()
        const canReadBilling = computed(() => can(PERMISSIONS.BILLING_READ))
        watch(
            canReadBilling,
            (follow) => {
                if (follow) {
                    billingStore.start()
                } else {
                    billingStore.stop()
                }
            },
            { immediate: true }
        )
        onBeforeUnmount(() => billingStore.stop())

        // The Trial section follows the subscription. The billing store holds
        // it live, so the section goes when the trial converts or ends without
        // a reload; until the store has loaded (or for someone who can't read
        // billing) the account's status from sign-in answers, which the API
        // takes from the same subscription.
        const isTrial = computed(() => {
            const subscriptionStatus =
                billingStore.summary?.subscription?.status

            if (subscriptionStatus !== undefined) {
                return subscriptionStatus === 'trialing'
            }

            return sessionStore.data?.account?.data?.status === 'trial'
        })

        return {
            isTrial,
            isAdminUser,
            canManageBilling,
            billingStore,
            canReadBilling,
            onboardingStore,
            productTour,
            applicationMessage,
            applicationMessageReady,
        }
    },
    components: {
        EnvironmentPicker,
        EnvironmentOverlayBanner,
        BannerCarousel,
        SdkSetupWizard,
        GettingStartedChecklist,
        ProductTour,
        MobileNavMenu,
        ContactSupportSlideIn,
    },
    computed: {
        activeBanners() {
            const banners = []
            const billingAlert = this.billingStore.statusAlert
            if (this.canReadBilling && billingAlert) {
                banners.push({
                    key: 'billing-status',
                    component: BillingStatusBanner,
                    props: {},
                    bgClass: billingStatusBgClassFor(billingAlert),
                })
            }
            if (this.applicationMessageReady && this.applicationMessage) {
                banners.push({
                    key: 'announcement',
                    component: AnnouncementBanner,
                    props: { message: this.applicationMessage },
                    bgClass: announcementBgClass,
                })
            }
            return banners
        },
        sessionStore() {
            return useSessionStore()
        },
        authStore() {
            return useAuthStore()
        },
        account() {
            return this.sessionStore.data?.account?.data ?? {}
        },
        avatar() {
            const userUlid = this.sessionStore.data?.user?.data?.ulid
            if (!userUlid) {
                return ''
            }

            return import.meta.env.VITE_API_BASE + '/avatar/' + userUlid
        },
        current() {
            if (this.sessionStore.data === null) {
                return {}
            }

            return {
                projectKey: this.sessionStore.data.current.projectKey,
                environmentKey: this.sessionStore.data.current.environmentKey,
            }
        },
        isAdmin() {
            return this.$route.meta.admin
        },
        // Operational screens only: flags render their own notice, and the admin section already shows active swaps on the environments screen.
        showEnvironmentOverlayBanner() {
            return ['SEGMENTS', 'CONTEXTS', 'DEBUG', 'REPORTS'].includes(
                this.$route.meta.section
            )
        },
        isContexts() {
            return this.$route.meta.section === 'CONTEXTS'
        },
        isDebug() {
            return this.$route.meta.section === 'DEBUG'
        },
        isProfile() {
            return this.$route.meta.section === 'PROFILE'
        },
        isReports() {
            return this.$route.meta.section === 'REPORTS'
        },
        isSegments() {
            return this.$route.meta.section === 'SEGMENTS'
        },
        isFlags() {
            return this.$route.meta.section === 'FLAGS'
        },
        routeViewKey() {
            return JSON.stringify({
                name: this.$route.name ?? null,
                params: this.$route.params ?? {},
                query: this.$route.query ?? {},
            })
        },
        selected() {
            return 'bg-taupe-800 text-white'
        },
        showAdmin() {
            // Editors are granted project/environment/webhook access within
            // the admin section (see usePermissions ROLE_PERMISSIONS), so
            // the entry point isn't admin/owner-only.
            return ['admin', 'owner', 'editor'].includes(
                this.sessionStore.data?.user?.data?.effective_role
            )
        },
        showSidebar() {
            return this.$route.meta.sidebar ?? false
        },
        unselected() {
            return 'text-taupe-300 hover:text-white hover:bg-taupe-600'
        },
        user() {
            return this.sessionStore.data?.user?.data ?? null
        },
        currentEnvironmentKeys() {
            if (!this.sessionStore.data?.projects?.data?.length) {
                return { clientKey: '', mobileKey: '', serverKey: '' }
            }
            const projectKey = this.sessionStore.data?.current?.projectKey
            const environmentKey =
                this.sessionStore.data?.current?.environmentKey
            if (!projectKey || !environmentKey) {
                return { clientKey: '', mobileKey: '', serverKey: '' }
            }
            const project = this.sessionStore.data.projects.data.find(
                (p) => p.key === projectKey
            )
            const environment = project?.environments?.data?.find(
                (e) => e.key === environmentKey
            )
            return {
                clientKey: environment?.client_key ?? '',
                mobileKey: environment?.mobile_key ?? '',
                serverKey: environment?.server_key ?? '',
            }
        },
    },
    data() {
        return {
            message: '',
            showMobileMenu: false,
            showSdkWizard: false,
            showOnboardingButton: false,
            support: {
                show: false,
                processing: false,
                error: '',
                subject: '',
                message: '',
            },
        }
    },
    methods: {
        closeSupport() {
            this.support.show = false
            this.support.error = ''
        },
        async environmentChanged() {
            await this.$router.push({
                name: this.$route.meta.sidebar
                    ? this.$route.name
                    : 'ProjectFlagsScreen',
                params: this.current,
            })
        },
        moment(datetime) {
            return moment(datetime)
        },
        openSdkWizardFromMenu() {
            this.showSdkWizard = true
        },
        restartTour() {
            this.productTour.restart()
        },
        openHelp() {
            this.support.show = true
            this.support.error = ''

            if (this.support.subject === '') {
                this.support.subject = 'Need help with Zenmanage'
            }
        },
        async submitSupport() {
            const subject = this.support.subject.trim()
            const message = this.support.message.trim()

            if (subject === '' || message === '') {
                this.support.error = 'Subject and message are required.'
                return
            }

            this.support.processing = true
            this.support.error = ''

            try {
                await SupportTicketService.create({
                    subject,
                    message,
                    path: this.$route.fullPath,
                })

                this.support.message = ''
                this.closeSupport()
                successMessage(
                    'Support request submitted. We will follow up shortly.'
                )
            } catch (error) {
                this.support.error =
                    error?.message ||
                    'Unable to submit your support request right now.'
                errorMessage(error)
            } finally {
                this.support.processing = false
            }
        },
        async profile() {
            await this.$router.push({ name: 'ProfileDefaultScreen' })
        },
        async signout() {
            // Use auth store for logout
            const authStore = this.authStore

            try {
                await authStore.logout(true)
                await this.$router.push('/login')
            } catch {
                this.message = 'Session could not be ended.'
            }
        },
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu
        },
        async checkOnboardingFlag() {
            this.showOnboardingButton = await getFlag(
                'enable-new-onboarding',
                false
            )
        },
    },
    async mounted() {
        await this.checkOnboardingFlag()

        const onboardingStore = useOnboardingStore()
        const accountUlid = this.account?.ulid
        if (accountUlid) {
            onboardingStore.fetch(accountUlid)
        }
    },
    watch: {
        $route: {
            immediate: true,
            async handler(route) {
                if (route.meta.section !== 'FLAGS') return
                await this.$nextTick()
                this.productTour.start()
            },
        },
    },
}
</script>
